<script>
import GuestDocumentationMixin from '@/mixins/guestdocumentation'
import { helpers } from '@/helpers.js'

export default {
  name: 'GuestDocumentationTrafalgar',
  mixins: [ GuestDocumentationMixin ],
  computed: {},
  data () {
    return {
      isModalTermsAndConditionsToggle: false
    }
  },
  methods: {
    isInvalidContent (field = '') {
      return helpers.isInvalidContent(field)
    },
    toggleTermsAndConditionsModal () {
      this.isModalTermsAndConditionsToggle = !this.isModalTermsAndConditionsToggle
      document.body.classList.toggle('modal-open', this.isModalTermsAndConditionsToggle)
    },
    muted () {
      var video = document.getElementById('videoLoop')
      video.muted = true
    },
    printPage () {
      window.print()
    }
  }
}
// Issue #459 - https://gitlab.com/itereo/templates-jsreport/-/issues/84
// Bootsrap styles estuvieron sobreescribiendo estilos del print del pdf
// Solución: Cambiar selectores y estilos en la sección de itinerary para que no se vean afectados por los estilos de bootstrap
</script>
<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './main.scss';
@import './style-1.scss';
@import './print.scss';
@import './bootstrap.scss';
</style>

<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated delay-1s slow fadeIn" >

      <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu" >
        <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
          <span class="text show-menu-visible" :class="{ 'menu-visible': isMenuToggle }"></span>
          <span class="text hide-menu-visible" :class="{ 'menu-visible': isMenuToggle }">Menu</span>
          <span class="bars">
            <span class="bar1"></span>
            <span class="bar2"></span>
            <span class="bar3"></span>
          </span>
        </span>
      </button>
      <div class="cover-tittle">
        <div class="cover-logo">
          <a class="navbar-brand" href="#">
            <span class="logo">
              <img class="light-logo" src="/guestdocumentation/trafalgar/img/logo.png" alt="Logo">
            </span>
          </a>
        </div>
      </div>
      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
            <ul class="navbar-nav">
              <!--<li class="nav-item active">
                <a class="nav-link" href="#home">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>-->
              <li class="nav-item">
                <a class="nav-link" href="#introduction" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('introduction')">INTRODUCTION</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">ITINERARY</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">MAP</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#hotel" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('hotel')">HOTEL LIST</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#experiences" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('experiences')">OPTIONAL EXPERIENCES</a>
              </li>
            </ul>

          </div>
        </nav>
      </div>
    </header>
    <main class="page-main main-anim scrollpage-container animated fadeIn" id="mainpage" >
      <!--BEGIN  HOME -->
      <div
        class="background-home section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/trafalgar/img/bg-style-1.jpg)'}]"
        id="home">
        <div class="overlay-home overlay-home-mob"></div>

        <div class="section-wrapper animated delay-1s slow fadeIn">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description">
                  <div class="cover-slider-description">
                    <h1 class="cover-header-description-title1">
                      <i class="icon fa fa-calendar"></i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }} </span>
                      <i class="fa fa-arrow-right ml-2"> </i>
                      <i class="icon fa fa-calendar"> </i>
                      <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }} </span>
                      <i v-if="Array.isArray(d.itineraries.locations_visited) == true" class="fa fa-map-marker"></i>
                      <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}</span>
                    </h1>
                    <div class="cover-header-description-title2" >
                      TRIP INFORMATION
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.itineraries">
                        <span>{{ d.itineraries.titleitinerary }}</span>
                    </div>
                    <div class="cover-header-description-title4 txt-uppercase" v-if="d && d.properties_opportunity && d.reference_number">
                      {{ d.reference_number }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
      <!-- END HOME -->
      <!-- BEING LETTER -->
      <div class="section red info-area letter_after" data-section="introduction" id="introduction" >
          <div class="section-wrapper with-margin pb0">
            <div class="single-info row order-mobile">
              <div class="col-lg-5 blockA no-padding info-left">
                <div class="info-thumb img_letter_BG mt-0"
                :style="[ secondOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      secondOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/trafalgar/img/letter.jpg)'}]">
                  <!-- <img class="img_letter" src="/guestdocumentation/trafalgar/img/letter.jpg"> -->
                </div>
              </div>
              <div class="col-lg-7 blockB text-center no-padding info-rigth p-4 print-introduction">
                  <div class="info-content bg-white p-4 letter-box info-content-letter info-content-right">
                    <button class="button_print" @click="printPage"><i class="fa fa-print"></i>Print</button>
                     <!--PRINT: INTRODUCTION-->
                       <table id="print-header" class="print-only">
                          <tbody>
                             <tr>
                                <td width="70%">
                                   <h1 class="title_trip_info">TRIP<br> INFORMATION</h1>
                                </td>
                                <td width="10%"></td>
                                <td class="total-value" width="20%">
                                   <div id="logo" class="logo_print">
                                    <img class="light-logo" src="/guestdocumentation/trafalgar/img/logo.png" alt="Logo" width="270">
                                   </div>
                                </td>
                             </tr>
                             <tr>
                                <td width="70%" v-if="d && d.guest_documentation">
                                  <div class="border-trip-name">
                                   <h4>{{ d.itineraries.titleitinerary }}</h4>
                                  </div>
                                </td>
                                <td width="10%"></td>
                                <td class="trip-code-section" width="20%">
                                  <div class="print_info_it">
                                    <p id="trip-code-number-section" v-if="d && d.properties_opportunity && d.reference_number">TRIP CODE<strong id="trip-code">{{ d.reference_number }}</strong></p>
                                    <p id="trip-date-section" v-if="d && d.itineraries">TRIP DATE<strong id="trip-code">{{ d.itineraries.fromitinerary | custom-date }}</strong></p>
                                   </div>
                                </td>
                             </tr>
                          </tbody>
                       </table>
                     <!--PRINT: INTRODUCTION-->
                    <div v-html="d.guest_documentation.introduction"></div>
                  </div>
              </div>
            </div>
          </div>
      </div>
      <!-- END LETTER -->
      <!-- BEING ITINERARY -->
      <div class="section grey" data-section="itinerary" id="itinerary" >
        <div class="section-wrapper">
          <div class="section-content  anim">
            <div class="col-12 col-lg-12 anim cover-header-description-title2 mt-100">
              <div class="title-desc title-red no-print">
                <h2 class="h2">Itinerary</h2>
              </div>
              <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Your Travel Itinerary</h1></div>

            <!--PRINT: YOUR TRAVEL ITINERARY-->
            <ul id="days-box" class="print-only print__itinerary">
              <li :id="`day${index}`" v-for="(day, index) in d.itineraries.days" :key="index" class="print__itinerary--item">
                <div width="100%">
                  <h4 class="title-day-date">DAY {{ index + 1}} <span class="title-day" v-html="day.title"></span></h4>
                  <p class="dl-print">
                    <span v-if="day" class="date">{{ day.startdate | custom-date }}</span> / <span class="location"
                      v-if="day && day.locations && Array.isArray(day.locations)"> <span>{{ day.locations | custom-join('name')
                        }}</span>
                    </span>
                  </p>
                  <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                  <p v-if="day.meals">
                    <strong class="mr-1">MEAL(S):</strong>
                    <span>{{ day.meals | custom-join('mealsday') }}</span>
                  </p>
                  <p v-if="day.accommodation">
                    <strong class="mr-1">ACCOMMODATION:</strong>
                    <span>{{ day.accommodation}}</span>
                  </p>
                </div>
              </li>
            </ul>
            <!--PRINT: YOUR TRAVEL ITINERARY-->
            </div>
            <div class="row row-random grid-media-aside-text fade-3 no-print">
              <!-- <div class="col-md-6 border-card" v-for="(day, index) in d.itineraries.days" :class="{ inactive: d.itineraries.days }"  :key="index" @click="dayScrollTo(index)"> -->
              <div class="border-card"
              :class="{ 'col-md-6' : index != Object.keys(d.itineraries.days).length - 1 ||index === Object.keys(d.itineraries.days).length - 1 && Object.keys(d.itineraries.days).length % 2 === 0,
              'col-md-12' : index === Object.keys(d.itineraries.days).length - 1 && Object.keys(d.itineraries.days).length % 2 !== 0}"
              v-for="(day, index) in d.itineraries.days"
              :key="index" @click="dayScrollTo(index)">
                <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
                  <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
                  <img v-if="!day.url_image_1200_725" src="/guestdocumentation/trafalgar/img/day-img.jpg"/>

                  <div class="info">
                    <div class="text-inside">
                      <h1>DAY {{ day.startday }}</h1>
                      <!-- <span>{{ Object.keys(d.itineraries.days).length % 2 != 0 }}</span> -->
                      <p class="subtittle" v-html="day.title"></p>
                      <p class="date">
                        <i class="icon fa fa-calendar mr-2"></i>
                        <span v-if="day">{{ day.startdate | custom-date }}</span>
                      </p>
                      <p class="location">
                        <i class="fa fa-map-marker mr-2"></i>
                        <span v-if="day && day.locations && Array.isArray(day.locations)">{{ day.locations | custom-join('name') }}</span>
                      </p>
                      <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday">
                        <span v-html="day.textday[0].textday.substring(0,300)+'...'"></span>
                        <a href="javascript:void(0)" data-toggle='modal' class='underlineLink showMoreDay'>Show more</a>
                      </p>

                      <p v-if="day.meals">
                        <strong class="mr-1">MEAL(S):</strong>
                        <span>{{ day.meals | custom-join('mealsday') }}</span>
                      </p>
                      <p v-if="day.accommodation">
                        <strong class="mr-1">HOTEL:</strong>
                        <span>{{ day.accommodation}}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      <!-- END ITINERARY -->

      <!-- BEGIN INCLUDED -->
      <div
        class="section fullscreen-md-off no-footer bg-image info-area no-print"
        data-section="map" id="map"

        :style="[secondOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      secondOpporunityBackgroundImage
                    )}')`
                  } : {'background-image': '/guestdocumentation/trafalgar/img/bg-style-1.jpg'}]">

        <div class="bg-overlay">
          <div class="section-wrapper anim with-margin">
            <div class="title-desc title-back no-print">
              <h2 class="h2 mb-4">Map</h2>
              <p class="mb-5 mt-3">
                Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.
              </p>
            </div>
            <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Map</h1></div>
              <div class="col-12 col-md-12">
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>

          </div>
        </div>
      </div>
      <!-- END INCLUDED -->
      <!-- BEGIN HOTEL LIST -->
      <div class="section red"
        data-section="hotel" id="hotel">
        <div class="section-wrapper with-margin section-hotel">
          <div class="section-content anim paddig-container">
            <div class="title-desc no-print">
              <h2 class="h2 anim-2">Hotel List</h2>
            </div>
            <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1></div>
            <div class="row">
              <div class="col-12 col-md-12  text-left">
                  <div class="section-info white pr-4">
                    <div class="section-column">
                      <div v-html="d.guest_documentation.hotel_list"></div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- END HOTEL LIST -->
      <!-- BEGIN OPTIONAL EXPERIENCES -->
      <div class="section bg-level-2  bg-mark " data-section="experiences" id="experiences" v-if="!isInvalidContent(d.guest_documentation.optional_experience)">
        <img v-if="thirdOpporunityBackgroundImage != '' " :src="`${getParsedImageUrl(thirdOpporunityBackgroundImage)}`" alt="">
        <img v-else src="/guestdocumentation/trafalgar/img/bg-style-1.jpg" style="width:100%;">
        <div class="section-wrapper with-margin">
            <div class="section-content paddig-container">
              <div class="row">
                <div class="col-12 col-md-12 anim">
                  <div class="title-desc">
                    <h2 class="display-5 anim-2 text-center h2 option-title no-print">Optional Experiences</h2>
                  <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Optional Experiences</h1></div>
                    <div class="section-info white">
                      <div v-html="d.guest_documentation.optional_experience"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <!-- END OPTIONAL EXPERIENCES -->

      <footer >
        <div class="section-wrapper padding-footer ">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/guestdocumentation/trafalgar/img/logo-itp.png" width="80">
          </div>
          <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>
    </main>
    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen modalDays fade animated fadeIn show"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="overlaymd" @click="toggleModal"></div>
      <div class="section-header">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-12 cover-image section-text">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/guestdocumentation/trafalgar/img/day-img.jpg"/>
                  <div class="section_text_overlay">
                    <h1>DAY {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                  </div>
                </div>
                <div class="col-md-12 section-text">

                  <div class="align-vcenter">
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2">
                      <i class="fa fa-map-marker mr-2"></i>
                      <span v-if="day && day.locations && Array.isArray(day.locations)">{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">HOTEL:</strong>
                      <span>{{ day.accommodation}}</span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldownDay nextday" >
                    <a class="down" href="#section02">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
